(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ttt-accessibility"] && !Shopify.designMode) return;
  try {
    class TeaTroveAccessibility extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.start = () => {
        this.wrapper = document.querySelector('.global-wrapper');
        this.main = document.querySelector('#nathan-content');
        this.drawers = [...document.querySelectorAll('.cart_frm_side, .login_frm_side')];
        this.update = () => {
          if (this.main && !this.main.querySelector('main, [role="main"]')) this.main.setAttribute('role', 'main');
          this.labelQuantities();
          const active = this.drawers.find(drawer => document.body.classList.contains(drawer.matches('.cart_frm_side') ? 'cart-opened' : 'login-opened'));
          if (active && this.activeDrawer !== active) this.returnFocus = document.activeElement;
          this.drawers.forEach(drawer => {
            const open = drawer === active;
            drawer.inert = !open;
            drawer.setAttribute('aria-hidden', String(!open));
            if (open) drawer.setAttribute('aria-modal', 'true');
            else drawer.removeAttribute('aria-modal');
          });
          if (this.wrapper) this.wrapper.inert = Boolean(active);
          if (active && (active !== this.activeDrawer || !active.contains(document.activeElement))) {
            (active.querySelector('.close-cart') || active).focus({preventScroll: true});
          } else if (!active && this.activeDrawer) {
            const target = this.returnFocus?.isConnected ? this.returnFocus : document.querySelector('.ttt-header-actions a[href$="/cart"]');
            target?.focus({preventScroll: true});
          }
          this.activeDrawer = active;
        };
        this.keyboard = event => {
          const drawer = this.activeDrawer;
          if (!drawer) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            drawer.querySelector('.close-cart')?.click();
          } else if (event.key === 'Tab') {
            const focusable = [...drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')]
              .filter(el => !el.disabled && el.type !== 'hidden' && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
            const first = focusable[0], last = focusable.at(-1);
            if (!first) { event.preventDefault(); drawer.focus(); }
            else if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
        };
        this.observer = new MutationObserver(this.update);
        this.observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
        this.drawers.forEach(drawer => this.observer.observe(drawer, {childList: true, subtree: true}));
        if (this.main) this.observer.observe(this.main, {childList: true, subtree: true});
        document.addEventListener('keydown', this.keyboard);
        this.update();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once: true});
      else this.start();
    }
    labelQuantities() {
      document.querySelectorAll('#nathan-content .quantity, .cart_frm_side .cart-drawer__item-quantity, .cart_frm_side .quantity').forEach(group => {
        group.querySelectorAll('input[type="number"]').forEach(input => {
          if (!input.getAttribute('aria-label') && !input.labels?.length) input.setAttribute('aria-label', this.dataset.quantity);
        });
        group.querySelectorAll('.plus').forEach(button => button.setAttribute('aria-label', this.dataset.increase));
        group.querySelectorAll('.minus').forEach(button => button.setAttribute('aria-label', this.dataset.decrease));
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('DOMContentLoaded', this.start);
      document.removeEventListener('keydown', this.keyboard);
      if (this.wrapper) this.wrapper.inert = false;
      this.initialized = false;
    }
  }
  if (!customElements.get('tea-trove-accessibility')) customElements.define('tea-trove-accessibility', TeaTroveAccessibility);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttt-catalog-search"] && !Shopify.designMode) return;
  try {
    function initializeTeaSearch() {
    const form = document.querySelector('.ttt-search');
    const field = form?.querySelector('input[name="q"]');
    const panel = form?.querySelector('.ttt-search-suggestions');
    const source = document.getElementById('ttt-catalog-search-data');
    if (!field || !panel || !source || field.dataset.teaSearchReady) return;
    field.dataset.teaSearchReady = 'true';
    field.setAttribute('aria-controls', panel.id);
    field.setAttribute('aria-expanded', 'false');
    field.setAttribute('autocomplete', 'off');
    const products = JSON.parse(source.textContent);
    const list = panel.querySelector('ul');
    const close = () => { panel.hidden = true; field.setAttribute('aria-expanded', 'false'); };
    field.addEventListener('input', () => {
      const words = field.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      list.replaceChildren();
      if (!words.length) { close(); return; }
      const matches = products.filter(p => words.every(w => p.terms.includes(w))).slice(0, 6);
      for (const product of matches) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = product.url;
        const title = document.createElement('span');
        title.textContent = product.title;
        const price = document.createElement('span');
        price.textContent = product.price;
        link.append(title, price);
        item.append(link);
        list.append(item);
      }
      panel.querySelector('.ttt-search-status').textContent = `${matches.length} ${document.getElementById('ttt-search-count-label').textContent}`;
      panel.hidden = false;
      field.setAttribute('aria-expanded', 'true');
    });
    field.addEventListener('keydown', event => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowDown' && !panel.hidden && list.firstElementChild) { event.preventDefault(); list.querySelector('a')?.focus(); }
    });
    form.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); field.focus(); } });
    document.addEventListener('click', event => { if (!form.contains(event.target)) close(); });
    form.addEventListener('focusout', event => { if (!form.contains(event.relatedTarget)) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeTeaSearch); else initializeTeaSearch();
  document.addEventListener('shopify:section:load', initializeTeaSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttt-catalog-ui"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
    if (!event.target.matches('[data-ttt-sort]')) return;
    const grid = event.target.closest('[data-ttt-results]').querySelector('.ttt-catalog-grid');
    const cards = [...grid.children];
    cards.forEach((card,index) => { if (!card.dataset.originalOrder) card.dataset.originalOrder = String(index+1); });
    const choice = event.target.value;
    cards.sort((a,b) => choice === 'price-ascending' ? Number(a.dataset.price)-Number(b.dataset.price) : choice === 'price-descending' ? Number(b.dataset.price)-Number(a.dataset.price) : choice === 'title-ascending' ? a.dataset.title.localeCompare(b.dataset.title) : Number(a.dataset.originalOrder)-Number(b.dataset.originalOrder));
    grid.append(...cards);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttt-navigation-drawer"] && !Shopify.designMode) return;
  try {
    class TeaTroveNavigation extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.panel = 'root';
      this.triggers = () => [...document.querySelectorAll('[data-ttt-open-menu]')].filter(el => el.getAttribute('aria-controls') === this.dialog.id);
      this.selectPanel = (name, focus = true) => {
        this.panel = name;
        this.querySelectorAll('[data-ttt-menu-panel]').forEach(el => { el.hidden = el.dataset.tttMenuPanel !== name; });
        this.querySelector('[data-ttt-root-back]').hidden = name !== 'root';
        this.querySelector('[data-ttt-child-back]').hidden = name === 'root';
        this.querySelectorAll('[data-ttt-menu-target]').forEach(el => el.setAttribute('aria-expanded', String(el.dataset.tttMenuTarget === name)));
        this.dialog.scrollTop = 0;
        if (focus) this.querySelector('[data-ttt-menu-back]').focus({preventScroll: true});
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-ttt-open-menu]');
        if (!trigger || !this.triggers().includes(trigger)) return;
        this.opener = trigger;
        this.selectPanel('root', false);
        this.dialog.showModal();
        this.triggers().forEach(el => el.setAttribute('aria-expanded', 'true'));
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          return;
        }
        const target = event.target.closest('[data-ttt-menu-target]');
        if (target) this.selectPanel(target.dataset.tttMenuTarget);
        else if (event.target.closest('[data-ttt-menu-close], a[href]')) this.dialog.close();
        else if (event.target.closest('[data-ttt-menu-back]')) {
          if (this.panel === 'root') this.dialog.close();
          else {
            const previous = this.panel;
            this.selectPanel('root', false);
            this.querySelector('[data-ttt-menu-target="' + previous + '"]').focus({preventScroll: true});
          }
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.triggers().forEach(el => el.setAttribute('aria-expanded', 'false'));
        const target = this.opener?.getClientRects().length ? this.opener : this.triggers().find(el => el.getClientRects().length);
        target?.focus({preventScroll: true});
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled])')].filter(el => el.getClientRects().length && !el.closest('[hidden]'));
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus({preventScroll: true});
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus({preventScroll: true});
        }
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  }
  if (!customElements.get('tea-trove-navigation')) customElements.define('tea-trove-navigation', TeaTroveNavigation);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttt-quiz-engine"] && !Shopify.designMode) return;
  try {
    function createTeaQuizEngine(questions, products) {
    if (!Array.isArray(questions) || !questions.length || !Array.isArray(products)) throw new TypeError('Invalid tea finder configuration');
    const firstAsins = new Set(questions[0].answers.flatMap(answer => answer.asins));
    const seen = new Set();
    const eligible = products.filter(product => {
      if (!product.id || !firstAsins.has(product.asin) || seen.has(product.id)) return false;
      seen.add(product.id);
      return true;
    });
    let started = false;
    let history = [];
    function getState() {
      if (!started) return {kind: 'intro', choices: [], skipped: []};
      if (!eligible.length) return {kind: 'empty', products: [], choices: [], skipped: []};
      let candidates = eligible.slice();
      const skipped = [], choices = [];
      for (let index = 0; index < questions.length; index += 1) {
        const question = questions[index];
        const options = question.answers.filter(answer => candidates.some(product => answer.asins.includes(product.asin)));
        if (!options.length) { skipped.push(question.id); continue; }
        const selected = history[choices.length];
        if (!selected || selected.questionId !== question.id) return {kind: 'question', index, question, options, products: candidates.slice(), choices, skipped};
        const answer = options.find(option => option.id === selected.answerId);
        if (!answer) throw new Error('Invalid tea finder history');
        choices.push({questionId: question.id, answerId: answer.id, label: answer.label});
        candidates = candidates.filter(product => answer.asins.includes(product.asin));
      }
      return {kind: candidates.length ? 'results' : 'empty', products: candidates.slice(), choices, skipped};
    }
    return {
      getState,
      start() { started = true; history = []; return getState(); },
      choose(questionId, answerId) {
        const state = getState();
        if (state.kind !== 'question' || state.question.id !== questionId || !state.options.some(option => option.id === answerId)) return false;
        history.push({questionId, answerId});
        return getState();
      },
      back() { if (history.length) history.pop(); else started = false; return getState(); },
      restart() { started = true; history = []; return getState(); }
    };
  }

  class TeaTroveQuiz extends HTMLElement {
    connectedCallback() {
      if (!this.boundClick) this.boundClick = event => this.handleClick(event);
      this.addEventListener('click', this.boundClick);
      if (this.engine) return;
      try {
        const data = JSON.parse(this.querySelector('[data-quiz-data]').textContent);
        this.templates = new Map([...this.querySelectorAll('template[data-quiz-product]')].map(template => [template.dataset.quizProduct, template]));
        this.questions = data.questions;
        this.labels = data.labels;
        this.engine = createTeaQuizEngine(data.questions, data.products.filter(product => this.templates.has(product.id)));
        this.intro = this.querySelector('[data-quiz-intro]');
        this.stage = this.querySelector('[data-quiz-stage]');
        this.status = this.querySelector('[data-quiz-status]');
        this.browseUrl = this.querySelector('[data-quiz-fallback]').getAttribute('href');
        this.querySelector('[data-quiz-fallback]').hidden = true;
        this.querySelector('[data-quiz-action="start"]').hidden = false;
      } catch (error) {
        this.querySelector('[data-quiz-fallback]').hidden = false;
        this.querySelector('[data-quiz-action="start"]').hidden = true;
      }
    }
    disconnectedCallback() { this.removeEventListener('click', this.boundClick); }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    button(label, action, className = 'ttt-quiz-control') {
      const button = this.element('button', className, label);
      button.type = 'button';
      button.dataset.quizAction = action;
      return button;
    }
    handleClick(event) {
      const target = event.target.closest('[data-quiz-action]');
      if (!target || target.closest('tea-trove-quiz') !== this || !this.engine) return;
      const action = target.dataset.quizAction;
      let state;
      if (action === 'answer') state = this.engine.choose(target.dataset.question, target.dataset.answer);
      else if (['start', 'back', 'restart'].includes(action)) state = this.engine[action]();
      if (state) this.render(state);
    }
    progress(state) {
      const list = this.element('ol', 'ttt-quiz-progress');
      list.setAttribute('aria-label', this.labels.progress);
      this.questions.forEach((question, index) => {
        const type = state.choices.some(choice => choice.questionId === question.id) ? 'complete' : state.skipped.includes(question.id) ? 'skipped' : state.question?.id === question.id ? 'current' : 'upcoming';
        const item = this.element('li', 'is-' + type);
        const status = type === 'current' ? this.labels.active : this.labels[type];
        item.setAttribute('aria-label', `${index + 1}. ${question.title} — ${status}`);
        if (type === 'current') item.setAttribute('aria-current', 'step');
        const number = this.element('span', '', String(index + 1));
        number.setAttribute('aria-hidden', 'true');
        item.append(number);
        list.append(item);
      });
      return list;
    }
    render(state) {
      this.intro.hidden = state.kind !== 'intro';
      this.stage.hidden = state.kind === 'intro';
      this.stage.replaceChildren();
      if (state.kind === 'intro') {
        const heading = this.intro.querySelector('h2');
        this.setAttribute('aria-labelledby', heading.id);
        this.status.textContent = '';
        heading.focus({preventScroll: true});
        return;
      }
      if (state.kind !== 'empty') this.stage.append(this.progress(state));
      const heading = this.element('h2', 'ttt-quiz-title', state.kind === 'question' ? state.question.title : state.kind === 'results' ? this.labels.result_title : this.labels.empty_title);
      heading.id = 'ttt-quiz-stage-' + this.dataset.sectionId;
      heading.tabIndex = -1;
      this.setAttribute('aria-labelledby', heading.id);
      this.stage.append(heading);
      const description = state.kind === 'question' ? state.question.description : state.kind === 'results' ? this.labels.result_description : this.labels.empty_description;
      this.stage.append(this.element('p', 'ttt-quiz-description', description));
      if (state.kind === 'question') {
        this.stage.append(this.element('p', 'ttt-quiz-hint', this.labels.choose));
        const options = this.element('div', 'ttt-quiz-options');
        options.setAttribute('role', 'group');
        options.setAttribute('aria-labelledby', heading.id);
        state.options.forEach(answer => {
          const button = this.button(answer.label, 'answer', 'ttt-quiz-option');
          button.dataset.question = state.question.id;
          button.dataset.answer = answer.id;
          options.append(button);
        });
        this.stage.append(options);
        this.status.textContent = this.labels.question.replace('{number}', String(state.index + 1)).replace('{total}', String(this.questions.length));
      } else if (state.kind === 'results') {
        const count = state.products.length === 1 ? this.labels.result_count_one : this.labels.result_count.replace('{count}', String(state.products.length));
        this.stage.append(this.element('p', 'ttt-quiz-description', count));
        const choices = this.element('ul', 'ttt-quiz-answer-list');
        choices.setAttribute('aria-label', this.labels.answers);
        state.choices.forEach(choice => choices.append(this.element('li', '', choice.label)));
        this.stage.append(choices);
        const cards = this.element('div', 'ttt-quiz-results');
        state.products.forEach(product => cards.append(this.templates.get(product.id).content.cloneNode(true)));
        this.stage.append(cards);
        this.status.textContent = count;
      } else this.status.textContent = this.labels.empty_title;
      const controls = this.element('div', 'ttt-quiz-controls');
      controls.append(this.button(this.labels.back, 'back'));
      if (state.choices.length) controls.append(this.button(this.labels.restart, 'restart', 'ttt-quiz-control ttt-quiz-control-secondary'));
      this.stage.append(controls);
      if (state.kind !== 'question') {
        const browse = this.element('a', 'ttt-quiz-browse', this.labels.browse);
        browse.href = this.browseUrl;
        this.stage.append(browse);
      }
      heading.focus({preventScroll: true});
      const bounds = heading.getBoundingClientRect();
      if (bounds.top < 20 || bounds.bottom > window.innerHeight - 80) this.scrollIntoView({block: 'start', behavior: 'auto'});
    }
  }
  if (!customElements.get('tea-trove-quiz')) customElements.define('tea-trove-quiz', TeaTroveQuiz);
  } catch(e) { console.error(e); }
})();

})();
